import { createSharedComposable } from '@vueuse/core'
import type { MessagesComponents as components } from '@core/types'
import { ref, useXmppListener } from '#imports'

export const useUserNotificationsSubscriber = createSharedComposable(() => {
    const notification = ref<components['schemas']['RenderedNotification']>()

    if (import.meta.client) {
        useXmppListener({ kind: 'message', type: 'headline', xmlns: 'cego:notification' }, (notificationMessage: components['schemas']['RenderedNotification']) => {
            notification.value = Array.isArray(notificationMessage) ? notificationMessage[0] : notificationMessage
        })
    }

    return {
        notification,
    }
})
